module.exports = __webpack_public_path__ + "static/media/Vivo-step6.15de7f91.png";